/**
 * Config Module
 *
 * Application configuration for web
 */

export { appConfig, getConfig, useMagentoGraphQlUrl } from './app-config';
export type { AppConfig } from './app-config';
export * from './app-config';
export { GRAPHQL_PROXY_ENDPOINTS, useGraphQlEndpoint } from './graphql-endpoint-config';
export type { GraphQlTarget } from './graphql-endpoint-config';
